<div class="mat-text-display">
  @if (showLabel) {
    <label class="mat-caption text-muted">{{label}}</label>
  }
  <h3 class="mb-0 multiline">{{displayValue}}</h3>
</div>
